import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import api from "@/lib/api";
import { CookieBanner } from "@/components/CookieBanner";
import { AuthProvider } from "@/context/AuthContext";
import { I18nProvider } from "@/lib/i18n";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { AppShell } from "@/components/AppShell";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Home from "@/pages/Home";
import Discover from "@/pages/Discover";
import CreatorProfile from "@/pages/CreatorProfile";
import Campaigns from "@/pages/Campaigns";
import Messages from "@/pages/Messages";
import PaymentResult from "@/pages/PaymentResult";
import ProfilePage from "@/pages/ProfilePage";
import Legal from "@/pages/Legal";
import BusinessDetail from "@/pages/BusinessDetail";
import AdminDashboard from "@/pages/admin/Dashboard";
import AdminMemberDetail from "@/pages/admin/AdminMemberDetail";
import AdminInvoice from "@/pages/admin/AdminInvoice";

function Tracker() {
  const location = useLocation();
  useEffect(() => {
    api.post("/track", { path: location.pathname }).catch(() => {});
  }, [location.pathname]);
  useEffect(() => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.register("/sw.js").catch(() => {});
    }
  }, []);
  return null;
}

const withShell = (node) => (
  <ProtectedRoute roles={["commerce", "creator"]}>
    <AppShell>{node}</AppShell>
  </ProtectedRoute>
);

function App() {
  return (
    <div className="App">
      <I18nProvider>
        <AuthProvider>
          <BrowserRouter>
            <Tracker />
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/app" element={withShell(<Home />)} />
              <Route path="/discover" element={withShell(<Discover />)} />
              <Route path="/creators/:id" element={withShell(<CreatorProfile />)} />
              <Route path="/businesses/:id" element={withShell(<BusinessDetail />)} />
              <Route path="/campaigns" element={withShell(<Campaigns />)} />
              <Route path="/messages" element={withShell(<Messages />)} />
              <Route path="/payment/success" element={<PaymentResult />} />
              <Route path="/payment/cancel" element={<PaymentResult />} />
              <Route path="/profile" element={withShell(<ProfilePage />)} />
              <Route path="/legal/:doc" element={<Legal />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute roles={["admin"]}>
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />
              <Route path="/admin/member/:id" element={<ProtectedRoute roles={["admin"]}><AdminMemberDetail /></ProtectedRoute>} />
              <Route path="/admin/invoice/:sid" element={<ProtectedRoute roles={["admin"]}><AdminInvoice /></ProtectedRoute>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <CookieBanner />
          </BrowserRouter>
          <Toaster position="top-center" theme="dark" richColors />
        </AuthProvider>
      </I18nProvider>
    </div>
  );
}

export default App;
